import { render, staticRenderFns } from "./income.vue?vue&type=template&id=a0c9eafe&scoped=true"
import script from "./income.vue?vue&type=script&lang=js"
export * from "./income.vue?vue&type=script&lang=js"
import style0 from "./income.vue?vue&type=style&index=0&id=a0c9eafe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c9eafe",
  null
  
)

export default component.exports